const MONTH = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11,
};

export const parseSlugDate = slug => {
  const [day, month, year] = slug.split('-');
  return new Date(Number(year), MONTH[month.toLowerCase()], Number(day));
};
